import { Input, OnChanges, SimpleChanges, Directive } from '@angular/core';
import { Catalog } from '@df/catalog/catalog.interfaces';
import { AttributeResource } from '@df/catalog/attribute/attribute.resource';

/**
 * You can pass either option or value + attributeCode pair
 *
 * <swatch [option]="option"></swatch>
 * <swatch [value]="colorValue" attributeCode="color"></swatch>
 */
@Directive()
export class SwatchComponentDef implements OnChanges {
    @Input()
    value?: number;

    @Input()
    attributeCode?: string;

    @Input()
    selected?: boolean;

    @Input()
    option?: Catalog.IAttributeOption | 'checkbox';

    @Input()
    forcedImage?: string;

    constructor(private attributeResource: AttributeResource) {}

    ngOnChanges(changes: SimpleChanges) {
        if (changes['attributeCode'] || changes['value']) {
            this.option =
                this.value && this.attributeCode ? this.attributeResource.get(this.attributeCode)?.getOptionByValue(this.value) : undefined;
        }
    }

    protected getType(): 'image' | 'background' | 'checkbox' {
        if (this.forcedImage) {
            return 'image';
        }
        if (this.option && typeof this.option !== 'string') {
            if (this.option.hasImage) {
                return 'image';
            }
            return 'background';
        }
        return 'checkbox';
    }

    protected isCheckbox(): boolean {
        return this.option === 'checkbox';
    }

    protected get swatch(): string {
        if (this.forcedImage) {
            return this.forcedImage;
        }
        if (this.option && typeof this.option !== 'string') {
            return this.option.swatch || '';
        }
        return '';
    }
}
